import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../core/http/api.service';

@Component({
    selector: 'app-review-entity',
    templateUrl: './review-entity.component.html',
    styleUrls: ['./review-entity.component.css'],
    standalone: false
})
export class ReviewEntityComponent implements OnInit {
  entityId = '';
  reviews = [];
  currentRatings = [];

  constructor(private route: ActivatedRoute, private api: ApiService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.entityId = params['id']);
    this.getReviews();
  }

  getReviews(): void {
    this.api.getRatingsByEntities(this.entityId).subscribe((data) => {
      this.reviews = data.response;
      this.currentRatings = this.reviews[0].ratings.bhakts;
    });
  }

  remove(id: string, i): void {
    this.api.deleteRatings(id).subscribe((data) => {
      this.reviews.splice(i, 1);
    });
  }
}
